<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>/&nbsp;商品上下架</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">商品上下架</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form

                  style="margin-top:16px;padding-left:15px;"
                >
                  <fieldset>
                    <div class="form-group row m-b-15">
                     <label class="col-md-1 col-form-label">品牌名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="brandList"
                          key-field="brandId"
                          show-field="brandName"
                          @values="brandChange(brandId)"
                          placeholder="品牌名称"
                          v-model="brandId"
                          title=""
                          ref="brand"
                        ></v-selectpage>
                      </div>

                      <label class="col-md-1 col-form-label">系列名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="SeriesList"
                          key-field="seriesId"
                          show-field="seriesName"
                          placeholder="系列名称"
                          v-model="seriesId"
                          title=""
                          ref="series"
                        ></v-selectpage>
                      </div>

                      <label class="col-md-1 col-form-label ">商品名称</label>
                      <div class="col-md-2 ">
                        <input
                        type="text"
                        class="form-control"
                        placeholder="商品编号/商品名称"
                        v-model="fuzzy"
                      >
                      </div>
                      <div class="col-md-2">
                        <a class="btn btn-primary ButtonColor m-r-5" style="float:left;" @click="SearchClick">查询</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>
                <el-table :data="GoodsShelvesList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号"  width="60"  align="center"></el-table-column>
                  <el-table-column prop="goodsCode" label="商品编号"  align="center"></el-table-column>
                  <el-table-column prop="goodsName" label="商品名称" show-overflow-tooltip header-align="center"></el-table-column>
                  <el-table-column prop="packageRates" label="包装率"  align="center"></el-table-column>
                  <el-table-column prop="groupName" label="分组"  align="center"></el-table-column>
                  <el-table-column prop="brandName" label="品牌"  align="center"></el-table-column>
                  <el-table-column prop="seriesName" label="系列"  align="center"></el-table-column>
                  <el-table-column prop="sellingPrice" label="零售价（元）"  align="center"></el-table-column>
                  <el-table-column  prop="recomPrice" label="分销价（元）"  align="center"></el-table-column>
                  <el-table-column  prop="shopPrice" label="门店价（元）"  align="center"></el-table-column>
                  <el-table-column label="操作" width="280" fixed="right"  align="center">
                    <template slot-scope="scope">
                      <a class="btn btn-primary btn-sm ButtonColor" @click="DetailClick(scope.row)">详情</a>
                      <button class="btn btn-warning btn-sm ButtonColor" :disabled="scope.row.shopStatus == 1" @click="GoodShelves(scope.row)">上架</button>
                      <button class="btn btn-warning btn-sm ButtonColor" :disabled="scope.row.shopStatus !== 1" @click="GoodShelvesSecond(scope.row)">下架</button>
                      <!-- <button class="btn btn-primary btn-sm ButtonColor" v-if="scope.row.shopStatus == 1" @click="SetActivity(scope.row)">设置</button> -->
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">
       <div v-if="EditDialog === 3" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定下架?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSureGoods" :disabled = 'disabled'>确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定上架?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = 'disabled'>确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">设置</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="活动列表:" prop="floatType">
            <el-select
              clearable
              v-model="ruleForm.floatType"
              placeholder="请选择"
              class="DistributorMargin"
              style="width:100%"
            >
              <el-option
                v-for="item in activityList"
                :key="item.floatCode"
                :label="item.floatName"
                :value="item.floatCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled = "disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "InfoManagement",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      brandList:[],
      SeriesList:[],
      outerVisible: false,
      seriesId:'',
      brandId:'',
      fuzzy: '',
      EditDialog: 1,
      CurrentSelection: [],
      GoodsShelvesList:[],
      disabled: false,
      recom_id: '',
      shop_id: '',
      activityList: [],
      ruleForm: {},
      rules: {
        floatType: [{ required: true, message: "请选择活动类型", trigger: "blur" }]
      },
    };
  },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    if(this.$route.query.shopId){
      this.shop_id = this.$route.query.shopId;
    }
    if (this.$route.params && this.$route.params.searchContent) {
      this.brandId = this.$route.params.searchContent.brandId;
      this.seriesId = this.$route.params.searchContent.seriesId;
      this.fuzzy = this.$route.params.searchContent.fuzzy;
    }
    this.initdata();
    this.getGroupData();
  },
   watch:{
    pageNo: {
    　　handler(newName, oldName) {
            if(this.$route.params){
               this.pageNo = this.$route.params.pageNo
            }

       　　},
    　　immediate: true
    },
   pagesize:{
      　handler(newName, oldName) {

            if(JSON.stringify(this.$route.params) !== "{}"){
               this.pageSize = this.$route.params.pagesize;

            }

       　　},
    　　immediate: true
    }
  },
  computed: {
      pageNo:{
        set(val){
          if(val){

             this.pageindex = val
          }

        },
        get(){
       //   console.log('我被调用了') //msg1获取值时触发

        }
      },
      pagesize:{
        set(val){
          if(val){
             this.pageSize = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发

        }
      }
 },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    DetailClick(row) {
      this.$router.push({ path: "/o2ogoodsshelvesdetail", query:{ recomId : this.recom_id, shopId: this.shop_id} });
      let searchContent = { };
      searchContent.brandId = this.brandId;
      searchContent.seriesId = this.seriesId;
      searchContent.fuzzy = this.fuzzy;
      localStorage.setItem("goodlist", JSON.stringify({goodsId :row.goodsId,pageNo: this.pageindex,pageSize: this.pageSize,searchContent: searchContent}));
    },
    GoodShelves(row){
      this.CurrentSelection = row;
      this.outerVisible = true;
      this.EditDialog = 2;
    },
    GoodShelvesSecond(row){
      this.CurrentSelection = row;
      this.outerVisible = true;
      this.EditDialog = 3;
    },
    SetActivity(row){
      this.ruleForm = {};
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }
      this.CurrentSelection = row;
      this.outerVisible = true;
      this.EditDialog = 1;
      this.getActivity();
    },
    getGroupData(){
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/queryBrand",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.brandList = response.data.data.b2cGoodsBrandList;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    brandChange(id) {
      if(id){
        let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/queryBrand",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            brandId: id
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.SeriesList = response.data.data.b2cGoodsSeriesList;
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      }else{
        if(this.$refs.series){
          this.$refs.series.remove();
        }
        this.SeriesList = [];
      }
    },
    // 获取活动列表
    getActivity(){
      let that = this;
      const options = {
        url: "distribution/B2cFloatInfoController/queryFloatInfoList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.activityList = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    MakeSureGoods(){
      let that = this;
      this.disabled = true;
      const options = {
        url: "distribution/B2cSkuOnlineController/downShopB2cSkuOnline",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.CurrentSelection.recomId,
          shopId: that.shop_id,
          groupId: that.CurrentSelection.groupId,
          goodsId: that.CurrentSelection.goodsId,
          packageRates: that.CurrentSelection.packageRates,
          onlineId:  that.CurrentSelection.id,
        })
      };
      axios(options).then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
        if (response.data.code == 200) {
          that.initdata();
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
          http.handleEorrorCode(response,that);
        }
      })
        .catch(function(error) {
            that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    MakeSure(){
      let that = this;
      this.disabled = true;
      const options = {
        url: "distribution/B2cSkuOnlineController/upShopB2cSkuOnline",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.CurrentSelection.recomId,
          shopId: that.shop_id,
          groupId: that.CurrentSelection.groupId,
          goodsId: that.CurrentSelection.goodsId,
          packageRates: that.CurrentSelection.packageRates,
          onlineId:  that.CurrentSelection.id,
        })
      };
      axios(options).then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
        if (response.data.code == 200) {
          that.initdata();
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
          http.handleEorrorCode(response,that);
        }
      })
        .catch(function(error) {
            that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    SearchClick(){
      this.pageindex = 1;
      this.initdata();
    },
    MakeSureEdit(formName){
      let that = this;
      this.disabled = true;
      that.$refs[formName].validate(valid => {
        if (valid) {
          let that = this;
          this.disabled = true;
          const options = {
            url: "distribution/B2cSkuOnlineController/setB2cFloatSkuOnline",
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({
              recomId: that.CurrentSelection.recomId,
              groupId: that.CurrentSelection.groupId,
              goodsId: that.CurrentSelection.goodsId,
              packageRates: that.CurrentSelection.packageRates,
              floatType: that.ruleForm.floatType,
              shopId: that.shop_id
            })
          };
          axios(options).then(function(response) {
            that.disabled = false;
            if (response.data.code == 200) {
              that.outerVisible = false;
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response,that);
              that.outerVisible = false;
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
        }else{
          that.disabled = false;
        }
      });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cSkuOnlineController/queryShopGoods",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.recom_id,
          shopId: that.shop_id,
          fuzzy: that.fuzzy,
          brandId: that.brandId,
          seriesId: that.seriesId,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
          }
         that.GoodsShelvesList = response.data.data.records;
        } else {
         http.handleEorrorCode(response,that);
        }
      })

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/O2OShopSetting/O2OGoodsShelves.vue